window.addEventListener('load', function(){
  
  var _title = document.querySelector('.mrpoint-title');
  if (_title != null && _title != undefined) {
    _title.innerHTML = "";
  }
    
  var _p = document.createElement('p');
  if (_title != null && _title != undefined) {
    _p.innerHTML = "P";
    _p.classList.add("point_p");
    _title.appendChild(_p);
  }

  
  var _br = document.createElement('br');
  if (_title != null && _title != undefined) {
    _title.appendChild(_br);
  }
    
  var _point = document.createElement('p');
  if (_title != null && _title != undefined) {
    _point.innerHTML = "ポイント";
    _point.classList.add("point_po");
    _title.appendChild(_point);
  }

  var _mrpoint = document.querySelector('.mrpoint');
  if (_title != null && _title != undefined) {
    _mrpoint.classList.add("visible");
  }
  
});
